export default __webpack_public_path__ + "static/media/bg-pattern-intro-left-mobile.111709ef.svg";